import { DOCUSIGN_IMPLEMENTATION, LOGALTY_IMPLEMENTATION } from '../constants/steps';
import { formatText } from 'core/i18n';

export const getStepsTextsByImplementation = (implementation = DOCUSIGN_IMPLEMENTATION) => {
    switch (implementation) {
        case LOGALTY_IMPLEMENTATION:
            return {
                step1: {
                    title: formatText('signingPage-firmlogalty'),
                    description: formatText('signingPage-firmDescriptionLogalty'),
                },
                step2: {
                    title: formatText('signingPage-otpCode'),
                    description: formatText('signingPage-otpCodeDescription'),
                },
            };
        case DOCUSIGN_IMPLEMENTATION:
            return {
                step1: {
                    title: formatText('signingPage-SMSCode'),
                    description: formatText('signingPage-SMSCodeDescription'),
                },
                step2: {
                    title: formatText('signingPage-firm'),
                    description: formatText('signingPage-firmDescription'),
                },
            };
    }
};
